export default {
  trends: {
    title: "Price trends",
    subtitleBase: "Estimated ex-factory price trend from real history (SNS Generics 2010+ and PMAH).",
    disclaimer: "A statistical trend estimate, not a regulatory prediction nor a commitment: it guides, it does not decide. Dated future milestones live in the Calendar.",
    products: "products",
    upTo: "up to",
    yearsUnit: "years",
    ofHistory: "of history",
    horizonMonths: "{n} months",
    // Loading / error / empty states
    calculating: "Calculating forecasts…",
    calculatingDetail: "Loading real history, detecting events and training models.",
    noDataTitle: "Not enough data to generate forecasts",
    noDataDetail: "At least 3 price observations (SNS Generics or PMAH) per CN are required. When the history grows you'll see forecasts here.",
    // Product selector
    searchPlaceholder: "Search among {n} products (name or CN)…",
    noResults: "No results for «{query}»",
    moreHint: "+{n} more — refine your search",
    // Forecast chart
    model: "Model",
    chartHist: "Historical",
    chartForecast: "Forecast",
    bandInterval: "90% interval",
    histPrice: "Historical price",
    forecastLine: "Forecast",
    // Opportunity / risk panel
    marketOpportunity: "Market opportunity",
    opportunity: "Opportunity",
    noStrongSignals: "No strong signals detected",
    riskOneMonth: "1-month risk",
    riskSpike: "Sharp rise",
    riskDrop: "Sharp drop",
    riskAnomaly: "Anomaly",
    // Ranking + drivers
    opportunityRanking: "Opportunity ranking (top {n})",
    scoreLabel: "Score",
    detectedEvents: "Detected events (drivers)",
    noEvents: "No events identified.",
    // Backtest
    backtestTitle: "Temporal validation — backtest",
    thModel: "Model",
    thHorizon: "Horizon",
    thDirAcc: "Directional accuracy",
    // Event labels (drivers)
    eventGenericEntry: "Generic entry",
    eventPatentExpiration: "Patent expiration",
    eventRegulatoryApproval: "Regulatory approval",
    eventRegulatoryRejection: "Regulatory rejection",
    eventSafetyAlert: "Safety alert",
    eventWithdrawal: "Withdrawal",
    eventShortage: "Shortage",
    eventReimbursementChange: "Reimbursement change",
    eventExclusion: "PMAH exclusion",
    eventMergerAcquisition: "Merger / acquisition",
    eventLicenseAgreement: "License agreement",
    eventProductionChange: "Production change",
    eventLogisticsDisruption: "Logistics disruption",
    eventDemandChange: "Demand change",
    eventGeopoliticalSupply: "Supply risk",
    eventManufacturerConcentration: "Manufacturer concentration",
  },
};
